import DashboardAutoRefreshInterval, {
  DashboardAutoRefreshIntervalString
} from 'enums/DashboardAutoRefreshInterval'
import { getMemorizedStateFromSessionStorage } from 'utils/sessionStorageUtils'
import { UiSlice } from './types'

export const getAutoRefreshInterval = (interval: DashboardAutoRefreshIntervalString) => {
  const MIN_MS = 60 * 1000
  switch (interval) {
    case DashboardAutoRefreshInterval.ONE_MIN:
      return 1 * MIN_MS
    case DashboardAutoRefreshInterval.TWO_MIN:
      return 2 * MIN_MS
    case DashboardAutoRefreshInterval.FIVE_MIN:
      return 5 * MIN_MS
    case DashboardAutoRefreshInterval.TEN_MIN:
      return 10 * MIN_MS
    case DashboardAutoRefreshInterval.OFF:
    default:
      return 0 * MIN_MS
  }
}

export const shouldAutoRefreshEnable = ({
  interval,
  isPresentationMode
}: {
  interval: DashboardAutoRefreshIntervalString
  isPresentationMode: boolean
}) => {
  if (interval !== DashboardAutoRefreshInterval.OFF && isPresentationMode) return true
  return false
}

// * memorized state are from selectMemorizedStateForV4
export const getDefaultStatefromSessionStorage = () => {
  const memorizedState = getMemorizedStateFromSessionStorage()
  if (memorizedState) {
    return memorizedState.ui as Partial<UiSlice>
  }
  return null
}
